const getBasePath = () => {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '';
  if (!basePath || basePath === '/') {
    return '';
  }
  return `/${basePath.replace(/^\/+|\/+$/g, '')}`;
};

const EXTERNAL_URL_REGEX = /^(?:[a-z][a-z\d+.-]*:)?\/\//i;

export const assetUrl = (path: string) => {
  if (!path || EXTERNAL_URL_REGEX.test(path) || path.startsWith('data:')) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const basePath = getBasePath();

  if (
    !basePath ||
    normalizedPath === basePath ||
    normalizedPath.startsWith(`${basePath}/`)
  ) {
    return normalizedPath;
  }

  return `${basePath}${normalizedPath}`;
};
